const strictBoolean = {
  $validator: (value) => {
    return [, true, false].includes(value);
  },
  // $message: 'test cool'
};

export default strictBoolean;
